import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import '../../../util/rxjsExtensao.util';

import { environment } from '../../../../environments/environment';
import { Environment } from '../models/configuracaoAmbiente.model';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  environment: Environment = null;

  constructor(private http: HttpClient) {
    this.environment = environment as unknown as Environment;
  }
}

/**
 * Objeto de Mock, utilizado para carregar os dados do arquivo de configuração
 *
 * @export
 * @class MockAppSettingsService
 * @extends {AppSettingsService}
 */
export class MockAppSettingsService extends AppSettingsService {}

export const AppSettingsServiceMemory = {
  provide: AppSettingsService,
  useClass: MockAppSettingsService,
};
